import React, { Component } from "react"
import { Link, graphql } from "gatsby"
import Layout from "../layouts"
import Img from "gatsby-image"
// import SEO from "../components/seo"

// import { rhythm } from "../utils/typography"

class NewsTemplate extends Component {
    constructor(props) {
      super(props)
      const { pageContext } = this.props;
      this.state = {
        activeCategory: pageContext.slug
      }
    }
    render() {
        const data = this.props.data
        const { activeCategory } = this.state
    
    
        return (
            <Layout page="news">
              <section className="section news">
                <div className="container">
                  <div className="news__social">
                    <h1>@VisitFilms on Social</h1>
                    <div id="curator-feed-news-layout"><a href="https://curator.io" target="_blank" className="crt-logo crt-tag">Powered by Curator.io</a></div>
                  </div>
                </div>
                
              </section>
              <></>
              <section className="section news">
                <div className="container">
                    <h1>News</h1>
                    <div className="filter--tabs filter--tabs--news">
                        <Link to="/news" >
                            <div className={activeCategory !== "" ? "filter--tab": "filter--tab active"} >All</div>
                        </Link>
                        {data.allWordpressCategory.edges.map(({ node, i }) => (
                            <Link to={"/news/" + node.slug} key={node.slug.replace(/ /g, "_")} >
                                <div className={activeCategory !== node.slug ? "filter--tab": "filter--tab active"} data-tag="" >{node.name}</div>
                            </Link>
                        ))}
                    </div>
                    <div className="news__feed">

                      {data.allWordpressPost.edges.map(({ node }) => (
                        <div className="news__article" key={node.id}>
                            {node.categories? node.categories.map( (category)  => 
                                <Link to="/news" key={category.name.replace(/ /g, "_")} >
                                  {/* <Link to={"news/" + category.slug} > */}
                                  <div className="news__category">{category.name}</div>
                                </Link>
                            ): null}
                            {node.featured_media && node.featured_media.localFile? <div className="news__img"><Img src={node.featured_media.localFile.childImageSharp.fluid.src} fluid={node.featured_media.localFile.childImageSharp.fluid} /></div>: null}
                            <Link to={"/" + node.slug}>
                            <h2>{node.title}</h2>
                            </Link>
                            <div dangerouslySetInnerHTML={{ __html: node.content }} />
                            <div className="news__border"></div>
                        </div>
                        ))}
                    </div>
                </div>    
              </section>
              
          </Layout>
        )
      }
}
export default NewsTemplate

export const pageQuery = graphql`
  query ($slug: String!) {
    allWordpressPost(filter: {categories: {elemMatch: {slug: {eq: $slug}}}}) {
        edges {
            node {
              title
              content
              slug
              id
              categories {
                name
                slug
              }
              featured_media {
                  localFile {
                      childImageSharp {
                          fluid(maxWidth: 1200) {
                              ...GatsbyImageSharpFluid
                            }
                        }
                    }
                }
            }
          }
    }
    allWordpressCategory(filter: {parent_element: {slug: {eq: "news"}}}) {
        edges {
          node {
            id
            name
            slug
          }
        }
      }
  }
`
